<script lang="ts">
  import CloseIcon from "../../images/close-button.svg";

  export let onCloseClick: () => void;
  export let isHeaderShown: boolean;
  export let clientLogoHeader: string | null

  $: isHeaderShown = isHeaderShown;
</script>

{#if isHeaderShown}
  <div class="crtw-flex crtw-justify-center crtw-mt-[50px]">
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div
      class="crtw-float-right crtw-cursor-pointer crtw-h-8 crtw-w-8 crtw-absolute crtw-top-0 crtw-right-0 crtw-z-1000001 crtw-m-2 crtw-bg-white crtw-rounded-full sm:crtw-m-4"
      on:click={onCloseClick}
      role="button"
      tabindex={0}
    >
      <img
        src={CloseIcon}
        alt="close-icon"
        class="crtw-fill-red-500 crtw-w-8 crtw-h-8 crtw-border crtw-rounded-full"
      />
    </div>

    {#if clientLogoHeader}
      <img src={clientLogoHeader} class="crtw-w-[150px] crtw-h-10" alt="client app logo">
    {/if}
  </div>
{/if}
